export default {
      id: "clipboard-check-usage",
      viewBox: "0 0 21 21",
      url: "/dist/svg/" + "sprite.svg#clipboard-check-usage",
      toString: function () {
        return this.url;
      }
    }